import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActiveUserService } from 'src/app/services/activeuser.service';
import { RecommendationService } from 'src/app/services/recommendation.service';
import { Client } from '../../generated-api-proxy';
import { ResultViewModel } from '../../models/result-view-model';
import { Subscription } from 'rxjs';
import { Brand } from 'src/brands/brand';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit {
  public loaded: boolean = false;
  readonly combinedLayout = Brand.resultLayout === 'combined';
  result: ResultViewModel = ResultViewModel.empty();
  private loggedInChangedSubscription: Subscription | undefined;

  constructor(private activeUser: ActiveUserService, private router: Router, private client: Client, private recommendationService: RecommendationService) { }

  ngOnInit(): void {
    this.loadResult();

    this.loggedInChangedSubscription = this.activeUser.loggedInChanged.subscribe({
      next: (loggedIn: boolean) => {
        if (loggedIn) {
          this.loadResult();
        }
      }
    });
  }

  ngOnDestroy() {
    if (this.loggedInChangedSubscription) {
      this.loggedInChangedSubscription.unsubscribe();  
    }
  }

  loadResult(): void {
    if (this.activeUser.LoggedIn()) {
      this.client.results().subscribe({
        next: result => {
          const viewModel = new ResultViewModel(result);
          this.recommendationService.getRecommendationKeysForRisk(viewModel.total.risk).subscribe(keys => {
            if (keys.length > 0) {
              viewModel.recommendationKeys = keys;
            }
            this.result = viewModel;
            this.redirectToWelcome(!this.result.gamtest.missing);
            this.loaded = true;
          });
        },
        error: error => {
          let newResult = ResultViewModel.empty();
          newResult.recommendationKeys.push('si_pts_recommendation_self_control_1');
          newResult.recommendationKeys.push('si_pts_recommendation_budget_1');
          newResult.recommendationKeys.push('si_pts_recommendation_problem_gambling_1');
          this.result = newResult;
          this.redirectToWelcome(false);
          this.loaded = true;
        }
      });
    }
  }

  redirectToWelcome(hasGamtest: boolean) {
    if (sessionStorage.getItem('welcomeShown'))
      return;

    if (!hasGamtest) {
      sessionStorage.setItem('welcomeShown', 'true');
      this.router.navigate(['/welcome']);
    }
  }
}
